<div class="row mb-2">
  <div class="col">
    <div class="card shadow-sm" *ngIf="loading">
      <div class="card-body">
        <div class="k-i-loading ml-1 mr-1" style="font-size: 32px;"></div>
        <span class="ml-2">Carregando Meu Cardápio Pay...</span>
      </div>
    </div>

    <div class="alert alert-warning" *ngIf="!loading && !empresa.meucardapioPay">
      Não foi possível carregar a configuração padrão do Meu Cardápio Pay.
      <span *ngIf="erroCarregarMeucardapioPay">{{erroCarregarMeucardapioPay}}</span>
    </div>

    <ng-container *ngIf="!loading && empresa.meucardapioPay">
    <section class="migration-cellcoin-banner" *ngIf="podeExibirBannerMigracaoCellcoin()">
      <div class="migration-cellcoin-icon">
        <i class="fas fa-bolt"></i>
      </div>
      <div class="migration-cellcoin-copy">
        <span>Meu Cardápio Pay 2.0</span>
        <strong>{{tituloBannerMigracaoCellcoin()}}</strong>
        <small>{{descricaoBannerMigracaoCellcoin()}}</small>
        <small class="text-danger" *ngIf="erroMigracaoCellcoin">{{erroMigracaoCellcoin}}</small>
      </div>
      <button type="button"
              class="btn btn-primary"
              [disabled]="carregandoMigracaoCellcoin"
              (click)="abraMigracaoCellcoin()">
        <span class="spinner-border spinner-border-sm mr-1" *ngIf="carregandoMigracaoCellcoin"></span>
        {{carregandoMigracaoCellcoin ? 'Consultando...' : textoBotaoMigracaoCellcoin()}}
      </button>
    </section>

    <!-- Status Ativo -->
    <div class="card meucardapio-pay-ativo shadow-sm" *ngIf="deveExibirCardMeucardapioPay()">
      <div class="card-body tuna-ativado">
        <!-- Cabeçalho com Status -->
        <div class="row cadastro-dados mb-3">
          <div class="col-md-6">
            <div class="d-flex align-items-center mb-1">
              <div class="status-icon mr-3">
                <i class="fas fa-check-circle text-success fa-2x"></i>
              </div>
              <div class="flex-grow-1">
                <h4 class="mb-0 text-success">Meu Cardápio Pay</h4>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-3">loja id: <strong>{{empresa.meucardapioPay.idLoja}}</strong></small>
                  <small class="text-muted mr-3">provedor: <strong>{{empresa.meucardapioPay?.provedor }}</strong></small>
                  <small class="text-muted" *ngIf="empresa.meucardapioPay?.cellcoinAccount?.account">
                    conta: <strong>{{empresa.meucardapioPay?.cellcoinAccount?.account}}</strong></small>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex align-items-center">
              <div class="btn-group mt-2">
                <a href="https://console.tuna.uy/meu-cardapio/meu-cardapio/{{empresa.meucardapioPay.idLoja}}"
                   target="_blank"
                   class="btn btn-sm btn-outline-primary"
                   *ngIf="!ehCellcoin()">
                  <i class="fas fa-external-link-alt mr-1"></i>
                  Acessar Painel Tuna Pay
                </a>
                <a href="/download/Tuna-Manual-Cliente.pdf"
                   target="_blank"
                   class="btn btn-sm btn-outline-secondary"
                   *ngIf="ehTuna()">
                  <i class="fas fa-book mr-1"></i>
                  Manual
                </a>
                <button type="button"
                        class="btn btn-sm btn-outline-secondary"
                        *ngIf="podeGerenciarWebhooksCellcoin()"
                        (click)="abraModalWebhooksCellcoin()">
                  <i class="fas fa-plug mr-1"></i>
                  Gerenciar Webhooks
                </button>
                <button type="button"
                        class="btn btn-sm btn-outline-primary"
                        *ngIf="podeVerDetalhesContaCellcoin()"
                        (click)="abraPaginaDetalhesContaCellcoin()">
                  <i class="fas fa-university mr-1"></i>
                  Ver detalhes da conta
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row status-ativacao ">
          <div class="col-md-6">
            <!-- Status da Conta -->
            <div [hidden]="cadastroAprovadoMCPay()">
              <div class="info-box">
                <div class="info-label">
                  <i class="fas fa-info-circle mr-1"></i>
                  Status da Conta
                </div>
                <div class="d-flex align-items-center" *ngIf="processando()">
                    <span class="badge badge-info">
                      <i class="k-icon k-i-reload mr-1"></i>
                      Processando...
                    </span>

                </div>

                <div class="d-flex align-items-center" *ngIf="estaEmAnalise()">
                    <span class="badge badge-info">
                      <i class="fas fa-clock mr-1"></i>
                      Em análise
                    </span>
                    <button class="btn btn-light btn-sm ml-2"
                            title="Verificar status"
                            kendoTooltip
                            [hidden]="empresa.meucardapioPay.sincronizando"
                            (click)="sincronizeStatusRegistroMCIPay()">
                      <i class="fas fa-sync-alt"></i>
                    </button>
                    <button class="btn btn-primary btn-sm ml-2"
                            *ngIf="possuiValidacaoDocumentosCellcoin()"
                            (click)="abraValidacaoDocumentosCellcoin()">
                      Continuar validação Cellcoin
                    </button>
                    <div class="spinner-border spinner-border-sm text-primary ml-2"
                         *ngIf="empresa.meucardapioPay.sincronizando"
                         role="status">
                      <span class="sr-only">Carregando...</span>
                    </div>
                  </div>

                <div class="alert alert-danger mb-0" *ngIf="naoAprovado()">
                  <i class="fas fa-exclamation-triangle mr-2"></i>
                  <strong>Cadastro não aprovado</strong>
                  <p class="mb-0 mt-2">Entre em contato com nossa equipe de suporte pelo WhatsApp para mais informações.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <!-- Data de Ativação -->
            <div [hidden]="!empresa.meucardapioPay.dataAtivacao || true">
              <div class="info-box">
                <div class="info-label">
                  <i class="far fa-calendar-check mr-1"></i>
                  Data de Ativação
                </div>
                <div class="d-flex align-items-center">
                  <i class="far fa-calendar-alt text-primary mr-2"></i>
                  <strong>{{empresa.meucardapioPay.dataAtivacao | date: 'dd/MM/yyyy HH:mm:ss'}}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Taxas Atuais -->
        <div class="row  ">
          <div class="col-md-6">
            <div class="payment-method-box">
              <div class="d-flex align-items-center">
                <img src="https://user-images.githubusercontent.com/33992396/99478353-00e4d600-2933-11eb-8228-4bafe8571507.png"
                     alt="PIX"
                     class="payment-icon"/>
                <div class="ml-3">
                  <h6 class="mb-1">PIX</h6>
                  <div class="d-flex align-items-center">
                    <span class="text-muted mr-2">Taxa:</span>
                    <span class="badge badge-success">
                      <span *ngIf="empresa.meucardapioPay.pixTaxaNegociada">
                        {{empresa.meucardapioPay.pixTaxaNegociada | number:'1.2-2'}}%
                      </span>
                      <span *ngIf="!empresa.meucardapioPay.pixTaxaNegociada">
                        {{empresa.meucardapioPay.contratoMeucardapioPay.taxaPix * 100 | number:'1.2-2'}}%
                      </span>
                    </span>
                    <button class="btn btn-sm btn-link ml-2" *ngIf="podeAlterarTaxaPix()" (click)="abrirModalNegociarPix()">
                      <i class="fas fa-edit fa-lg"></i> Alterar Taxa
                    </button>
                  </div>
                  <div class="cellcoin-pix-key" *ngIf="chavePixCellcoinAtiva()">
                    <span>Chave Pix EVP:</span>
                    <code>{{statusPixCellcoin().chave || statusPixCellcoin().chaveMascarada}}</code>
                  </div>
                </div>
              </div>

              <div class="payment-release-inline" *ngIf="podeExibirLiberacaoPixNoCard()">
                <div class="payment-release-title">
                  <div>
                    <strong>Liberar forma de pagamento</strong>
                    <span class="badge ml-2" [ngClass]="classeStatusLiberacaoCellcoin(statusPixCellcoin())">{{textoStatusPixCellcoin()}}</span>
                  </div>
                  <button type="button"
                          class="btn btn-light btn-sm"
                          [disabled]="carregandoLiberacaoCellcoin"
                          (click)="carregueStatusLiberacaoCellcoin()">
                    <span class="spinner-border spinner-border-sm mr-1" *ngIf="carregandoLiberacaoCellcoin"></span>
                    Atualizar
                  </button>
                </div>

                <div class="release-checks">
                  <div [class.ok]="statusLiberacaoCellcoin?.contaAtiva">
                    <i class="fas" [ngClass]="statusLiberacaoCellcoin?.contaAtiva ? 'fa-check-circle' : 'fa-clock'"></i>
                    Conta ativa
                  </div>
                  <div [class.ok]="statusPixCellcoin().chaveCriada">
                    <i class="fas" [ngClass]="statusPixCellcoin().chaveCriada ? 'fa-check-circle' : 'fa-clock'"></i>
                    Chave PIX criada
                    <small *ngIf="statusPixCellcoin().chaveMascarada">({{statusPixCellcoin().chaveMascarada}})</small>
                  </div>
                  <div [class.ok]="statusPixCellcoin().formaCriada">
                    <i class="fas" [ngClass]="statusPixCellcoin().formaCriada ? 'fa-check-circle' : 'fa-clock'"></i>
                    Forma pagamento Pix criada
                  </div>
                </div>

                <div class="alert alert-danger mb-3" *ngIf="erroLiberacaoPixCellcoin">{{erroLiberacaoPixCellcoin}}</div>

                <button type="button"
                        class="btn btn-primary"
                        [disabled]="!podeLiberarPixCellcoin() || liberandoPixCellcoin"
                        (click)="liberePixCellcoin()">
                  <span class="spinner-border spinner-border-sm mr-1" *ngIf="liberandoPixCellcoin"></span>
                  {{statusPixCellcoin().pronto ? 'Pix liberado' : textoBotaoPixCellcoin()}}
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="payment-method-box">
              <div class="d-flex align-items-center">
                <i class="fas fa-credit-card fa-2x text-primary payment-icon"></i>
                <div class="ml-3">
                  <h6 class="mb-1">Cartão</h6>
                  <div class="d-flex align-items-center">
                    <span class="text-muted mr-2">Taxa:</span>
                    <span class="badge badge-success">
                       <span *ngIf="empresa.meucardapioPay.cartaoTaxaNegociada">
                         {{empresa.meucardapioPay.cartaoTaxaNegociada   | number:'1.2-2'}}%
                       </span>
                       <span *ngIf="!empresa.meucardapioPay.cartaoTaxaNegociada">
                         {{empresa.meucardapioPay.contratoMeucardapioPay.taxaCartao * 100 | number:'1.2-2'}}%
                       </span>
                    </span>
                    <button class="btn btn-sm btn-link ml-2" *ngIf="podeAlterarTaxaCartao()" (click)="abrirModalNegociar()">
                      <i class="fas fa-edit fa-lg"></i> Alterar Taxa
                    </button>
                  </div>
                </div>
              </div>

              <div class="payment-release-inline" *ngIf="podeExibirLiberacaoCartaoNoCard()">
                <div class="payment-release-title">
                  <div>
                    <strong>Liberar forma de pagamento</strong>
                    <span class="badge ml-2" [ngClass]="classeStatusLiberacaoCellcoin(statusCartaoCellcoin())">{{textoStatusCartaoCellcoin()}}</span>
                  </div>
                  <button type="button"
                          class="btn btn-light btn-sm"
                          [disabled]="carregandoLiberacaoCellcoin"
                          (click)="carregueStatusCredenciamentoCartaoCellcoin()">
                    <span class="spinner-border spinner-border-sm mr-1" *ngIf="carregandoLiberacaoCellcoin"></span>
                    Atualizar
                  </button>
                </div>

                <div class="release-checks">
                  <div [class.ok]="statusLiberacaoCellcoin?.contaAtiva">
                    <i class="fas" [ngClass]="statusLiberacaoCellcoin?.contaAtiva ? 'fa-check-circle' : 'fa-clock'"></i>
                    Conta ativa
                  </div>
                  <div [class.ok]="statusCartaoCellcoin().credenciado" [class.erro]="statusCartaoCellcoin().status === 'CREDENCIAMENTO_REJEITADO'">
                    <i class="fas" [ngClass]="statusCartaoCellcoin().credenciado ? 'fa-check-circle' : (statusCartaoCellcoin().status === 'CREDENCIAMENTO_REJEITADO' ? 'fa-times-circle' : 'fa-clock')"></i>
                    Credenciamento na Subadquirência
                    <small *ngIf="statusCartaoCellcoin().accreditationId">({{statusCartaoCellcoin().accreditationId}})</small>
                  </div>
                  <div [class.ok]="statusCartaoCellcoin().formaCriada">
                    <i class="fas" [ngClass]="statusCartaoCellcoin().formaCriada ? 'fa-check-circle' : 'fa-clock'"></i>
                    Forma Cartão criada
                  </div>
                </div>

                <div class="alert alert-info mb-3" *ngIf="statusCartaoCellcoin().status === 'CREDENCIAMENTO_EM_ANALISE'">
                  Solicitação enviada. O cartão será liberado automaticamente quando o credenciamento for aprovado.
                </div>

                <div class="alert alert-danger mb-3" *ngIf="statusCartaoCellcoin().status === 'CREDENCIAMENTO_REJEITADO'">
                  Erro no credenciamento.
                  <span *ngIf="statusCartaoCellcoin().erro">{{statusCartaoCellcoin().erro}}</span>
                </div>

                <div class="alert mb-3"
                     *ngIf="mensagemConsultaCredenciamentoCartaoCellcoin"
                     [ngClass]="classeMensagemConsultaCredenciamentoCartaoCellcoin()">
                  {{mensagemConsultaCredenciamentoCartaoCellcoin}}
                </div>

                <div class="alert alert-danger mb-3" *ngIf="erroLiberacaoCartaoCellcoin">{{erroLiberacaoCartaoCellcoin}}</div>

                <button type="button"
                        class="btn btn-primary"
                        [disabled]="!podeLiberarCartaoCellcoin() || liberandoCartaoCellcoin"
                        (click)="abraLiberacaoCartaoCellcoin()">
                  <span class="spinner-border spinner-border-sm mr-1" *ngIf="liberandoCartaoCellcoin"></span>
                  {{statusCartaoCellcoin().pronto ? 'Cartão liberado' : textoBotaoCartaoCellcoin()}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Seção de Ativação -->
    <div class="card ativar-pagamento-meucadapio shadow-sm"
         *ngIf="deveExibirCardAtivacaoMeucardapioPay()">
      <div class="card-body">
        <div class="d-flex align-items-center mb-3">
          <i class="fas fa-star text-warning fa-2x mr-2"></i>
          <h4 class="mb-0">Ative o Meu Cardápio Pay!</h4>
        </div>

        <div class="alert alert-light border">
          <div class="row">
            <div class="col-md-6">
              <div class="d-flex align-items-center mb-3">
                <img src="https://user-images.githubusercontent.com/33992396/99478353-00e4d600-2933-11eb-8228-4bafe8571507.png"
                     style="width: 32px;" class="mr-2"/>
                <div>
                  <h5 class="mb-0">PIX</h5>
                  <small class="text-muted">Taxa por transação:</small>
                  <span class="badge badge-success ml-2">{{empresa.meucardapioPay.contratoMeucardapioPay.taxaPix * 100}}%</span>
                </div>
              </div>


              <div class="d-flex align-items-center mb-3"  >
                <span style="margin-left: -12px;">
                  <img src="/images/google-pay-logo.svg" alt="Google Pay" class="google-pay-logo  ">
                  <i class="fab fa-apple-pay fa-2x  " style="width: 60px;text-align: center;}"></i>
                </span>
                <div>
                  <h5 class="mb-0">

                    Carteiras Digitais
                   </h5>
                  <small class="text-muted">Taxa por transação:</small>
                  <span class="badge badge-success ml-2">
                    {{(empresa.meucardapioPay.contratoMeucardapioPay.taxaCartao  * 100 )   -  0.01}}%</span>
                </div>
              </div>

            </div>

            <div class="col-md-6">

              <div class="text-center mt-4">
                <button class="btn btn-lg btn-primary"
                        [disabled]="empresa.meucardapioPay.sincronizando"
                        (click)="ativeMeuCardapioPay()">
                  <i class="fe-plus-circle mr-2"></i>
                  Ativar Meu Cardápio Pay
                </button>
                <div class="mt-2 text-muted">
                  <small><i class="fas fa-shield-alt mr-1"></i> Ativação rápida e segura</small>
                </div>
              </div>


            </div>
          </div>
        </div>



        <div class="row mt-4 vantagens">
          <div class="col-md-3">
            <div class="text-center">
              <i class="fas fa-bolt text-warning fa-2x mb-2"></i>
              <h6>Ativação Imediata</h6>
              <small class="text-muted">Comece a receber em minutos</small>
            </div>
          </div>
          <div class="col-md-3">
            <div class="text-center">
              <i class="fas fa-hand-holding-usd text-success fa-2x mb-2"></i>
              <h6>Taxas Competitivas</h6>
              <small class="text-muted">Melhores taxas do mercado</small>
            </div>
          </div>
          <div class="col-md-3">
            <div class="text-center">
              <i class="fas fa-calendar-check text-info fa-2x mb-2"></i>
              <h6>Recebimento Garantido</h6>
              <small class="text-muted"> Pix D+0 próximo dia útil <br>

                Carteiras Digitais D+30</small>
            </div>
          </div>
          <div class="col-md-3">
            <div class="text-center">
              <i class="fas fa-headset text-primary fa-2x mb-2"></i>
              <h6>Suporte Dedicado</h6>
              <small class="text-muted">Atendimento especializado</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    </ng-container>
  </div>
</div>

<kendo-dialog title="Gerenciar Webhooks Cellcoin"
              *ngIf="mostrarModalWebhooksCellcoin"
              (close)="fecheModalWebhooksCellcoin()"
              class="cellcoin-webhooks-dialog"
              [minWidth]="320"
              [width]="980"
              [maxHeight]="innerHeight - 40">
  <div class="cellcoin-webhooks-modal">
    <div class="cellcoin-webhooks-toolbar">
      <label>
        <span>Host público</span>
        <input type="text"
               class="form-control"
               name="hostWebhooksCellcoin"
               placeholder="https://seu-dominio.com.br"
               [(ngModel)]="hostWebhooksCellcoin"
               (ngModelChange)="mudouHostWebhooksCellcoin()"
               (blur)="normalizeHostWebhooksCellcoinNoCampo()"
               [disabled]="carregandoWebhooksCellcoin || !!salvandoWebhookCellcoinKey || !!removendoWebhookCellcoinEntityKey"/>
      </label>

      <div class="cellcoin-webhooks-toolbar-actions">
        <button type="button"
                class="btn btn-light"
                [disabled]="carregandoWebhooksCellcoin || !!salvandoWebhookCellcoinKey || !!removendoWebhookCellcoinEntityKey"
                (click)="carregueWebhooksCellcoin()">
          <span class="spinner-border spinner-border-sm mr-1" *ngIf="carregandoWebhooksCellcoin"></span>
          Atualizar lista
        </button>
        <button type="button"
                class="btn btn-primary"
                [disabled]="!podeSalvarTodosWebhooksCellcoin()"
                (click)="salveTodosWebhooksCellcoin()">
          <span class="spinner-border spinner-border-sm mr-1" *ngIf="salvandoTodosWebhooksCellcoin()"></span>
          Atualizar todos
        </button>
      </div>
    </div>

    <div class="cellcoin-webhooks-auth" *ngIf="statusWebhooksCellcoin?.auth">
      <span>Auth padrão</span>
      <strong>{{statusWebhooksCellcoin.auth.login}}</strong>
      <code>{{statusWebhooksCellcoin.auth.pwd}}</code>
    </div>

    <div class="alert alert-danger" *ngIf="erroWebhooksCellcoin">
      {{erroWebhooksCellcoin}}
    </div>

    <div class="cellcoin-webhooks-loading" *ngIf="carregandoWebhooksCellcoin && !webhooksCellcoin().length">
      <div class="k-i-loading mr-2"></div>
      Consultando webhooks na Cellcoin...
    </div>

    <div class="cellcoin-webhooks-list" *ngIf="webhooksCellcoin().length">
      <div class="cellcoin-webhook-card" *ngFor="let grupo of gruposWebhooksCellcoin(); trackBy: trackByGrupoWebhookCellcoin">
        <div class="cellcoin-webhook-head">
          <div>
            <small>Endpoint no Meu Cardápio</small>
            <strong>{{grupo.path}}</strong>
          </div>
          <span class="cellcoin-webhook-summary">
            {{quantidadeWebhooksConfigurados(grupo)}}/{{grupo.webhooks.length}} configurados
          </span>
        </div>

        <div class="cellcoin-webhook-url">
          <span>URL do endpoint</span>
          <code>{{grupo.webhookUrlEsperada}}</code>
        </div>

        <div class="cellcoin-webhook-entities">
          <div class="cellcoin-webhook-entity" *ngFor="let webhook of grupo.webhooks; trackBy: trackByWebhookCellcoin">
            <div class="cellcoin-webhook-entity-info">
              <strong>{{webhook.entity}}</strong>
              <small>{{webhook.label}} · {{webhook.product}}<span *ngIf="webhook.context"> · {{webhook.context}}</span></small>
              <small class="cellcoin-webhook-url-diferente"
                     *ngIf="webhook.webhookUrlAtual && webhook.webhookUrlAtual !== webhook.webhookUrlEsperada">
                URL configurada: {{webhook.webhookUrlAtual}}
              </small>
              <small class="text-danger" *ngIf="webhook.erro">{{webhook.erro}}</small>
            </div>
            <span class="cellcoin-webhook-entity-status">
              <span class="spinner-border spinner-border-sm"
                    *ngIf="webhookCellcoinEntitySalvando(webhook)"></span>
              <span class="badge" [ngClass]="classeStatusWebhookCellcoin(webhook)">
                {{webhookCellcoinEntitySalvando(webhook) ? 'Atualizando' : webhook.statusTexto}}
              </span>
              <button type="button"
                      class="btn btn-outline-danger btn-sm cellcoin-webhook-remove"
                      title="Remover webhook"
                      *ngIf="webhook.subscriptionId"
                      [disabled]="!!removendoWebhookCellcoinEntityKey"
                      (click)="removaWebhookCellcoin(webhook, $event)">
                <span class="spinner-border spinner-border-sm" *ngIf="webhookCellcoinEntityRemovendo(webhook)"></span>
                <span class="fa fa-trash" aria-hidden="true" *ngIf="!webhookCellcoinEntityRemovendo(webhook)"></span>
                {{webhookCellcoinEntityRemovendo(webhook) ? 'Removendo' : 'Remover'}}
              </button>
            </span>
          </div>
        </div>

        <div class="cellcoin-webhook-actions">
          <button type="button"
                  class="btn btn-primary"
                  [disabled]="!grupoWebhooksCellcoinPodeSalvar(grupo)"
                  (click)="salveGrupoWebhooksCellcoin(grupo)">
            <span class="spinner-border spinner-border-sm mr-1" *ngIf="grupoWebhooksCellcoinSalvando(grupo)"></span>
            Atualizar
          </button>
        </div>
      </div>
    </div>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="fecheModalWebhooksCellcoin()">Fechar</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="mostrarModalCredenciamentoCartaoCellcoin"
              class="card-accreditation-dialog"
              (close)="fecheModalCredenciamentoCartaoCellcoin()"
              [minWidth]="320"
              [width]="860">
  <kendo-dialog-titlebar (close)="fecheModalCredenciamentoCartaoCellcoin()">
    <div class="card-accreditation-title">
      <span class="card-accreditation-title-icon">
        <i class="far fa-credit-card" aria-hidden="true"></i>
      </span>
      <strong>Credenciamento cartão</strong>
    </div>
  </kendo-dialog-titlebar>

  <div class="card-accreditation-form card-accreditation-modal">
    <div class="card-accreditation-head">
      <span class="card-accreditation-head-icon">
        <i class="far fa-file-alt" aria-hidden="true"></i>
      </span>
      <div>
        <strong>Dados para credenciamento</strong>
        <span>Usados para solicitar a liberação do cartão na Cellcoin.</span>
      </div>
    </div>

    <div class="card-accreditation-grid">
      <label [class.invalid-field]="campoCredenciamentoCartaoInvalido('softDescriptor')">
        <span>Nome na fatura</span>
        <input type="text"
               class="form-control"
               maxlength="18"
               name="cellcoinCardSoftDescriptor"
               placeholder="Nome da loja na fatura"
               [(ngModel)]="parametrosCredenciamentoCartao.softDescriptor"
               [class.is-invalid]="campoCredenciamentoCartaoInvalido('softDescriptor')"
               [disabled]="liberandoCartaoCellcoin"/>
        <div class="invalid-feedback d-block" *ngIf="campoCredenciamentoCartaoInvalido('softDescriptor')">
          {{mensagemCampoCredenciamentoCartao('softDescriptor')}}
        </div>
        <small>{{ajudaCampoCredenciamentoCartao('softDescriptor')}}</small>
      </label>

      <label [class.invalid-field]="campoCredenciamentoCartaoInvalido('cnae')">
        <span>CNAE Principal da empresa</span>
        <input type="text"
               class="form-control"
               maxlength="7"
               inputmode="numeric"
               name="cellcoinCardCnae"
               placeholder="Ex: 5611201"
               [(ngModel)]="parametrosCredenciamentoCartao.cnae"
               [class.is-invalid]="campoCredenciamentoCartaoInvalido('cnae')"
               [disabled]="liberandoCartaoCellcoin"/>
        <div class="invalid-feedback d-block" *ngIf="campoCredenciamentoCartaoInvalido('cnae')">
          {{mensagemCampoCredenciamentoCartao('cnae')}}
        </div>
        <small>{{ajudaCampoCredenciamentoCartao('cnae')}}</small>
      </label>

      <label [class.invalid-field]="campoCredenciamentoCartaoInvalido('businessDescriptor')">
        <span>Descrição do negócio</span>
        <input type="text"
               class="form-control"
               maxlength="100"
               name="cellcoinCardBusinessDescriptor"
               placeholder="Atividade comercial da loja"
               [(ngModel)]="parametrosCredenciamentoCartao.businessDescriptor"
               [class.is-invalid]="campoCredenciamentoCartaoInvalido('businessDescriptor')"
               [disabled]="liberandoCartaoCellcoin"/>
        <div class="invalid-feedback d-block" *ngIf="campoCredenciamentoCartaoInvalido('businessDescriptor')">
          {{mensagemCampoCredenciamentoCartao('businessDescriptor')}}
        </div>
        <small>{{ajudaCampoCredenciamentoCartao('businessDescriptor')}}</small>
      </label>

      <label [class.invalid-field]="campoCredenciamentoCartaoInvalido('monthlyIncome')">
        <span>Faturamento mensal</span>
        <kendo-numerictextbox class="form-control"
                              name="cellcoinCardMonthlyIncome"
                              placeholder="R$ 0,00"
                              format="c2"
                              [min]="0"
                              [decimals]="2"
                              [(ngModel)]="parametrosCredenciamentoCartao.monthlyIncome"
                              [class.is-invalid]="campoCredenciamentoCartaoInvalido('monthlyIncome')"
                              [disabled]="liberandoCartaoCellcoin">
        </kendo-numerictextbox>
        <div class="invalid-feedback d-block" *ngIf="campoCredenciamentoCartaoInvalido('monthlyIncome')">
          {{mensagemCampoCredenciamentoCartao('monthlyIncome')}}
        </div>
        <small>{{ajudaCampoCredenciamentoCartao('monthlyIncome')}}</small>
      </label>

      <div class="card-accreditation-site">
        <span class="card-accreditation-site-icon">
          <i class="fas fa-globe" aria-hidden="true"></i>
        </span>
        <div>
          <span>Site usado no credenciamento</span>
          <strong>{{siteCredenciamentoCartao || 'Domínio da loja não encontrado'}}</strong>
          <small>{{origemParametroCredenciamentoCartao('website')}}</small>
        </div>
      </div>
    </div>
  </div>

  <div class="alert alert-danger card-accreditation-error" *ngIf="erroLiberacaoCartaoCellcoin">
    {{erroLiberacaoCartaoCellcoin}}
  </div>

  <kendo-dialog-actions class="card-accreditation-actions">
    <button kendoButton
            class="card-accreditation-cancel"
            [disabled]="liberandoCartaoCellcoin"
            (click)="fecheModalCredenciamentoCartaoCellcoin()">Cancelar</button>
    <button kendoButton
            class="card-accreditation-submit"
            [primary]="true"
            [disabled]="liberandoCartaoCellcoin"
            (click)="libereCartaoCellcoin()">
      <span class="spinner-border spinner-border-sm mr-1" *ngIf="liberandoCartaoCellcoin"></span>
      <span>Iniciar credenciamento</span>
      <i class="fas fa-arrow-right" aria-hidden="true" *ngIf="!liberandoCartaoCellcoin"></i>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<div class="card shadow-sm" *ngIf="!loading && podeGerarFormasPagamentoMeucardapioPay()">
  <div class="card-body d-flex align-items-center justify-content-between">
    <div>
      <h5 class="mb-1">{{tituloGerarFormasPagamento()}}</h5>
      <p class="text-muted mb-0">Gere as formas de pagamento liberadas do Meu Cardápio Pay para vender com este provedor.</p>
    </div>
    <button type="button"
            class="btn btn-primary ml-3"
            [disabled]="sincronizandoFormasPagamento"
            (click)="sincronizeFormasPagamentoMeucardapioPay()">
      <span class="spinner-border spinner-border-sm mr-1" *ngIf="sincronizandoFormasPagamento"></span>
      Gerar formas de pagamento
    </button>
  </div>
</div>

<div *ngIf="possuiFormasPagamentoDoProvedor()">
  <app-grid-formas-de-pagamento  [empresa]="empresa" [online]="true"
                                 [formasDePagamento]="formasDePagamentoMciOnline" [loading]="loading">

  </app-grid-formas-de-pagamento>
</div>


<kendo-dialog title="Negociar Taxa Cartão" *ngIf="mostrarModalNegociar" (close)="fecharModalNegociar()" [minWidth]="300" [width]="450">
  <div class="row">
      <div class="col-md-12">
          <div class="form-group">
              <label>Taxa Negociada (%)</label>
              <kendo-numerictextbox
                  [(ngModel)]="taxaNegociada"
                  [min]="1"
                  [max]="100"
                  [format]="obtenhaFormatoPercentual()"
                  [decimals]="2">
              </kendo-numerictextbox>
              <small class="form-text text-muted">
                  Taxa Contrato: {{empresa.meucardapioPay.contratoMeucardapioPay.taxaCartao * 100 | number:'1.2-2'}}%
              </small>
          </div>
      </div>

    <div class="col-md-12 mt-2" *ngIf="erroTaxa">
        <div  class="alert alert-danger">
          {{erroTaxa}}
        </div>
    </div>
  </div>
  <kendo-dialog-actions>
      <button kendoButton (click)="fecharModalNegociar()">Cancelar</button>
      <button kendoButton (click)="salvarTaxaNegociada()"  [primary]="true" [disabled]="salvandoTaxa">Salvar</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog title="Negociar Taxa PIX" *ngIf="mostrarModalNegociarPix" (close)="fecharModalNegociarPix()" [minWidth]="300" [width]="450">
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>Taxa Negociada (%)</label>
        <kendo-numerictextbox
          [(ngModel)]="taxaNegociadaPix"
          [min]="0"
          [max]="10"
          [format]="obtenhaFormatoPercentual()"
          [decimals]="2">
        </kendo-numerictextbox>
        <small class="form-text text-muted">
          Taxa Contrato: {{empresa.meucardapioPay.contratoMeucardapioPay.taxaPix * 100 | number:'1.2-2'}}%
        </small>
      </div>
    </div>

    <div class="col-md-12 mt-2" *ngIf="erroTaxaPix">
      <div class="alert alert-danger">
        {{erroTaxaPix}}
      </div>
    </div>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="fecharModalNegociarPix()">Cancelar</button>
    <button kendoButton (click)="salvarTaxaNegociadaPix()" [primary]="true" [disabled]="salvandoTaxaPix">Salvar</button>
  </kendo-dialog-actions>
</kendo-dialog>
